import xs from 'xstream'

export function intent({ Time, DOM }) {
  const { speed$: defaultAcceleration$ } = params(DOM)

  const scroller = DOM.select('[data-rowslider-scroller]')
  const scroller$ = scroller.element()
  const row$ = DOM.select('[data-rowslider-row]').element()

  const logos = DOM.select('[data-rowslider-element]')
  const mouseenter$ = logos.events('mouseenter')
  const mouseleave$ = logos.events('mouseleave')
  const mouseTrigger$ = xs
    .merge(mouseenter$.mapTo(true), mouseleave$.mapTo(false))
    .compose(Time.debounce(100))
    .startWith(false)

  const focus$ = logos.events('focus')
  const blur$ = logos.events('blur')
  const focusTrigger$ = xs
    .merge(
      focus$.map(x => x.target),
      blur$.mapTo(false),
    )
    .startWith(false)

  const scrollStart$ = scroller.events('scroll').compose(Time.throttleAnimation)
  const scrollEnd$ = scrollStart$.compose(Time.debounce(25))

  const isScrolling$ = xs
    .merge(scrollStart$.mapTo(true), scrollEnd$.mapTo(false))
    .startWith(false)

  const pause$ = xs
    .combine(mouseTrigger$, focusTrigger$, isScrolling$)
    .map(([mouse, focus, scrolling]) => mouse || focus || scrolling)
    .startWith(false)

  const resize$ = DOM.window().events('resize')
  const slideLeft$ = slideButtonIntent(
    { Time, DOM },
    '[data-rowslider-slide-left]',
  )
  const slideRight$ = slideButtonIntent(
    { Time, DOM },
    '[data-rowslider-slide-right]',
  )
  const scrollLeft$ = scrollStart$.map(x => x.target.scrollLeft)
  const deltaTime$ = Time.animationFrames().map(({ delta }) => delta)
  const normalizedDeltaTime$ = Time.animationFrames().map(
    ({ normalizedDelta }) => normalizedDelta,
  )

  const isScrollable$ = resize$
    .startWith({})
    .compose(Time.throttleAnimation)
    .map(() => xs.combine(scroller$, row$))
    .flatten()
    .map(([scroller, row]) => {
      const { paddingLeft, paddingRight } = window.getComputedStyle(scroller)
      const innerWidth =
        scroller.clientWidth -
        parseFloat(paddingLeft) -
        parseFloat(paddingRight)
      return row.clientWidth > innerWidth
    })

  return {
    normalizedDeltaTime$,
    defaultAcceleration$,
    isScrollable$,
    scrollLeft$,
    slideRight$,
    slideLeft$,
    deltaTime$,
    resize$,
    pause$,
  }
}

export default intent

function slideButtonIntent({ Time, DOM }, selector) {
  return xs
    .merge(
      DOM.select(selector).events('click').mapTo(true),
      DOM.select(selector).events('mousedown').mapTo(true),
      DOM.select(selector)
        .events('mouseup')
        .compose(Time.delay(1))
        .mapTo(false),
      DOM.select(selector).events('mouseleave').mapTo(false),
      DOM.select(selector).events('blur').mapTo(false),
    )
    .startWith(false)
}

function params(DOMElement) {
  const params$ = DOMElement.element()
    .map(x => x.getAttribute('data-rowslider'))
    .map(x => JSON.parse(x) || {})

  return {
    speed$: params$
      .map(x => parseFloat(x.speed))
      .map(x => (!x && x != 0 ? 1 : x)), // default to 1 if x is not a number
  }
}



// WEBPACK FOOTER //
// ./rowSlider/intent.js